import { ReactNode } from 'react';
import {
  Dialog,
  DialogActions,
  DialogButton,
  DialogButtonProps,
  DialogContent,
  ModalInstance,
} from './utils';

const messageBox = new ModalInstance<MessageBoxOptions>('MessageBox');

export default function MessageBox() {
  const [options] = messageBox.useOptions();

  if (!options) {
    return null;
  }

  const buttons = options.buttons || [{ id: 'ok', title: 'OK' }];

  return (
    <Dialog onClose={() => messageBox.close('cancel')} title={options.title}>
      <DialogContent>{options.content}</DialogContent>
      <DialogActions>
        {buttons.map(({ id, ...button }) => (
          <DialogButton
            id={id}
            key={id}
            onClick={() => messageBox.close(id)}
            {...button}
          />
        ))}
      </DialogActions>
    </Dialog>
  );
}

export function showMessageBox<T extends ButtonId>(
  options: MessageBoxOptions<T>,
): ShowResult<T> {
  return messageBox.show(options) as any;
}

export interface MessageBoxOptions<T = ButtonId> {
  readonly buttons?: MessageBoxButton<T>[];
  readonly content: ReactNode;
  readonly title: string;
}

export interface MessageBoxButton<T = ButtonId> extends Omit<
  DialogButtonProps,
  'id'
> {
  readonly id: T;
}

type ButtonId<T = string> = NonNullable<
  MessageBoxOptions<T>['buttons']
>[number]['id'];
type ShowResult<T = ButtonId> = Promise<'cancel' | ButtonId<T>>;
